export default "__VITE_ASSET__CGxteWta__"